import dangoslenTheme from "../../../../../../themes/dangoslen";
import Code from "../../../../../../components/code/code";
import BorderedImg from "../../../../../../components/borderedimg/borderedimg";
import Follow from "../../../../../../components/follow/follow";
import Preso from "../../../../../../layouts/preso/preso";
import Footer from "../../../../../../components/footer/footer";
import TalkRelease from "../../../../../../images/TalkRelease.png";
import * as React from 'react';
export default {
  dangoslenTheme: dangoslenTheme,
  Code: Code,
  BorderedImg: BorderedImg,
  Follow: Follow,
  Preso: Preso,
  Footer: Footer,
  TalkRelease: TalkRelease,
  React: React
};